<div class="addContainer">

    <div class="contact-details">
      <div class="mb-3" *ngIf="isLoading">
        <mat-progress-bar color="primary" mode="indeterminate">
        </mat-progress-bar>
      </div>
      <div class="modalHeader">
        <div class="contact-details-name mb-1">View Group Members</div>
        <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div mat-dialog-content>
        <mat-card-content>
          <div *ngIf="isLoading">
            <div class="d-flex justify-content-center">
              <img src="assets/images/gif.gif" style="display: block; margin: auto; width: 60px; height: 60px" />
            </div>
          </div>
          <div *ngIf="!isLoading" class="body">
            <div class="table-responsi m-t-5">
              <div class="table-header py-3" style="background-color: rgba(239, 238, 242, 0.836); margin: 5px">
                <div class="row">
                  <div class="col-12 px-4">
                    <div class="mx-auto">
                      <input class="pull-left search form-control" (keyup)="applyFilter($event)" placeholder="Filter..."
                        #input />
                    </div>
                  </div>
                  <div class="col-6 px-4">
                    <div class="mx-auto">
                      <div class="m-l-10" [hidden]="!selection.hasValue()">
                        <button mat-mini-fab color="primary" (click)="proceed()" [class.auth-spinner]="multimodifyloading"
                          [disabled]="multimodifyloading">
                          <mat-icon class="col-white">done_all </mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
  
  
              <mat-table #table matTableExporter [dataSource]="dataSource" matSort class="mat-cell"
                #exporter="matTableExporter">
  
                <ng-container matColumnDef="select">
                  <mat-header-cell *matHeaderCellDef [ngClass]="'tbl-col-width-per-20'">
                  
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row" [ngClass]="'tbl-col-width-per-20'">
                   
                  </mat-cell>
                </ng-container>
  
                <ng-container matColumnDef="id">
                  <mat-header-cell *matHeaderCellDef mat-sort-header class="column-nowrap psl-3 tbl-col-width-per-20">Id
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row" class="column-nowrap psl-3 tbl-col-width-per-20">{{ row.id}}</mat-cell>
                </ng-container>
  
                <ng-container matColumnDef="member">
                  <mat-header-cell *matHeaderCellDef mat-sort-header class="column-nowrap psl-3 tbl-col-width-per-30">
                    Full Name
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row" class="column-nowrap psl-3 tbl-col-width-per-30">
                    {{ row.firstName +" "+row.lastName }}
                  </mat-cell>
                </ng-container>
  
                <ng-container matColumnDef="number">
                  <mat-header-cell *matHeaderCellDef mat-sort-header class="column-nowrap psl-3 tbl-col-width-per-25">
                    Member Number
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row" class="column-nowrap psl-3 tbl-col-width-per-25">
                    {{ row.memberNumber }}
                  </mat-cell>
                </ng-container>
  
  
               
                
  
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  
                <mat-row *matRowDef="let row; columns: displayedColumns" [style.cursor]="'pointer'" matRipple>
                </mat-row>
                <mat-cell *matNoDataRow colspan="4">
                  No data matching the filter "{{ input.value }}"
                </mat-cell>
              </mat-table>
  
              <!-- Loading spinner -->
              <div *ngIf="isLoading" class="tbl-spinner">
                <mat-progress-spinner color="primary" [diameter]="40" mode="indeterminate">
                </mat-progress-spinner>
              </div>
              <mat-paginator [pageSize]="8" [pageSizeOptions]="[1,2, 5, 10, 20, 30, 40, 50, 100]"
                aria-label="Select page of Communities"></mat-paginator>
            </div>
          </div>
        </mat-card-content>
      </div>
    </div>
  </div>